import { Messages } from "../../../core/api";
import { POCDocumentQuestionUI } from "./POCDocumentQuestionUI";
import { usePOCDocumentQuestion } from "./usePOCDocumentQuestion";

interface POCDocumentQuestionProps {
  questionId: number;
  questionText: string;
  currentAnswer: Messages["POCItemsDocumentAnswer"][] | null;
  POCItems: Messages["PatientDocumentPOCItem"][];
  isRequired: boolean;
  readonly: boolean;
  onClickWhileDisabled: () => void;
  onInsertAnswer: (id: number, answer: Messages["POCItemsDocumentAnswer"][]) => void;
}

export function POCDocumentQuestion(props: POCDocumentQuestionProps) {
  const { handleTaskCheck, handleWhenToPerformChange, handleFrequencyChange } =
    usePOCDocumentQuestion({
      questionId: props.questionId,
      currentAnswer: props.currentAnswer,
      readonly: props.readonly,
      onClickWhileDisabled: props.onClickWhileDisabled,
      onInsertAnswer: props.onInsertAnswer,
    });

  return (
    <POCDocumentQuestionUI
      currentAnswer={props.currentAnswer}
      isRequired={props.isRequired}
      POCItems={props.POCItems}
      questionId={props.questionId}
      questionText={props.questionText}
      readonly={props.readonly}
      onFrequencyChange={handleFrequencyChange}
      onTaskCheck={handleTaskCheck}
      onWhenToPerformChange={handleWhenToPerformChange}
    />
  );
}
